var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmModal',_vm._b({attrs:{"color":"error","icon":"mdi-delete","maxWidth":500,"itemKey":_vm.itemKey,"fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setQuestion":_vm.setQuestion,"confirmData":_vm.deleteData},on:{"onConfirm":(response) => _vm.$emit('onDelete', response)}},'ConfirmModal',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }